import { createScriptLoadQueue } from './script-load-queue';

type QueuedEvent = {
  eventName: string;
  params: facebook.Pixel.CustomParameters;
  eventData?: facebook.Pixel.EventIDOptions;
};

const send = ({ eventName, params, eventData }: QueuedEvent) => fbq('track', eventName, params, eventData);

const { queue: eventQueue, flush: flushFbqQueue, enqueue } = createScriptLoadQueue<QueuedEvent>({
  flushHook: '__flushFbqQueue',
  send,
});

/**
 * Sends an event to the Meta Pixel. The pixel loads `lazyOnload`, and only
 * after Marketing Consent, so an event that fires after consent but before
 * its init script has run (a fast form submit, a visit to a Conversion Page)
 * is queued and flushed by that script, through the same queue the Google tag
 * and the OpenAI Pixel use. An event fired before consent is dropped, not
 * queued, and only then does this return `false`.
 */
export function trackMetaEvent(
  eventName: string,
  params?: facebook.Pixel.CustomParameters,
  eventData?: facebook.Pixel.EventIDOptions,
): boolean {
  const event = { eventName, params: params ?? {}, eventData };
  if (typeof fbq === 'function') {
    send(event);
    return true;
  }
  return enqueue(event);
}

export { eventQueue, flushFbqQueue };
